import { Box } from "@mui/material";
import React, { useState } from "react";
import { globalStyles } from "../../../../styles/GlobalStyles";
import Images from "../../../../assets/Images";
import useGetTenantLogoQuery from "../../../tenantModule/hooks/useGetTenantLogoQuery";
import useAuthValue from "../../../authModule/hooks/useAuthValue";
import SuperUserHospitalDropdown from "./SuperUserHospitalDropdown";

const SuperUserHospitalSelector = () => {
  const { isLoggedIn, tenantId, hospitalId } = useAuthValue();
  const { data: tenantLogo } = useGetTenantLogoQuery(undefined, isLoggedIn);
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState<null | HTMLElement>(
    null
  );
  return (
    <>
      <Box
        onClick={(e) => {
          setDropdownAnchorEl(dropdownAnchorEl ? null : e.currentTarget);
        }}
        bgcolor="custom.background.primary"
        height={40}
        width={108}
        p={0.8}
        borderRadius={10}
        boxSizing="border-box"
        overflow="hidden"
        sx={[globalStyles.center, { cursor: "pointer" }]}
      >
        <img
          src={tenantLogo?.url ?? Images.MenuLogo}
          alt="Logo"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </Box>
      <SuperUserHospitalDropdown
        anchorEl={dropdownAnchorEl}
        open={Boolean(dropdownAnchorEl)}
        onClose={() => setDropdownAnchorEl(null)}
        tenantId={tenantId}
        hospitalId={hospitalId}
      />
    </>
  );
};

export default SuperUserHospitalSelector;
